import React from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useLocation } from 'react-router-dom';

import Textarea from '@scalero-inc/forno-textarea';
import Input from '@scalero-inc/forno-input';

import { useCreateOrderMutation } from 'hooks/api/cannoli-services';

import { InputField } from './utils';

import styles from './styles.module.css';
import OrderSummaryCard from '../order-summary-card';

function CheckoutForm() {
  const location = useLocation();

  React.useEffect(() => {
    const root = document.getElementById('root');
    if (root) root.scrollIntoView();
  }, [location]);

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const initialValues = {
    first_name: '',
    last_name: '',
    email: '',
    brief: '',
    number_of_tasks: 0,
    isTermsAccepted: false,
    wants_newsletter: false,
  };

  const validationSchema = Yup.object({
    first_name: Yup.string().required('Required').min(1),
    last_name: Yup.string().required('Required').min(1),
    email: Yup.string()
      .required('Required')
      .email('Invalid email address')
      .min(1),
    brief: Yup.string().required('Required').min(1),
    number_of_tasks: Yup.number().min(1, 'Invalid amount').required('Required'),
    isTermsAccepted: Yup.bool().oneOf([true], 'Policies must be accepted.'),
    wants_newsletter: Yup.bool(),
  });

  const mutation = useCreateOrderMutation({
    config: {
      onSuccess: (data) => {
        setIsSubmitting(false);
        window.location.assign(data.checkout);
      },
      onError: () => {
        setIsSubmitting(false);
        console.error('Error creating order');
      },
    },
  });
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        mutation.mutate(values);
        setIsSubmitting(true);
      }}
    >
      {(formik) => {
        return (
          <Form>
            <div className={styles['form-container']}>
              <div className={styles['form-inputs']}>
                <div className={styles['form-paired-inputs']}>
                  <Field
                    id="first_name"
                    name="first_name"
                    type="text"
                    as={Input}
                    label={<p className="paragraph-s">First Name*</p>}
                    warningText={
                      formik.touched.first_name && formik.errors.first_name
                    }
                  />
                  <Field
                    id="last_name"
                    name="last_name"
                    type="text"
                    as={Input}
                    label={<p className="paragraph-s">Last Name*</p>}
                    warningText={
                      formik.touched.last_name && formik.errors.last_name
                    }
                  />
                </div>
                <Field
                  id="email"
                  name="email"
                  type="email"
                  as={Input}
                  label={<p className="paragraph-s">Email*</p>}
                  warningText={formik.touched.email && formik.errors.email}
                />
                <InputField
                  name="brief"
                  label={
                    <span className={styles['description-label']}>
                      <p className="paragraph-s">Project Description*</p>
                      <p className="paragraph-s">
                        Make sure to add a description, Figma URLs, custom font
                        URLs and any other necessary information for us to
                        complete your project.
                      </p>
                    </span>
                  }
                  as={Textarea}
                />
                <InputField
                  name="number_of_tasks"
                  label={<p className="paragraph-s"># Number of Templates*</p>}
                  type="number"
                />
              </div>

              <OrderSummaryCard
                isDisabled={
                  !formik.isValid ||
                  isSubmitting ||
                  formik.values === initialValues
                }
                loading={isSubmitting}
                numberOfTasks={formik.values.number_of_tasks}
                formik={formik}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
}

export default CheckoutForm;
